import { Flex } from 'onefaceui-react-components';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  .react-tabs {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .tab-text {
    margin: 0;
  }
  .react-tabs__tab-panel {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .react-tabs__tab-list {
    margin: 0;
  }

  .stock-table-wrapper {
    height: calc(100vh - 500px);
  }
`;

export const SeeDetailsContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
`;

export const LastSync = styled(Flex)`
  background: var(--grey-300);
  padding: 0 8px;
  height: 32px;
`;
